var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable max-lines */
import React from 'react';
import { createRoutesFromElements, Route } from 'react-router-dom';

import { App } from "./App/App";
import { LibraryCards } from "./Library/Library";
import { LibraryMap } from "./Library/LibraryMap";
import { PreserveSettings, EntityTypesList, Settings } from "./Settings";
import { EditTemplate } from "./Templates/EditTemplate";
import NewTemplate from "./Templates/NewTemplate";
import { Login } from "./Users/Login";
import GeneralError from "./App/ErrorHandling/GeneralError";
import { Users, usersLoader, userAction } from "./V2/Routes/Settings/Users/Users";
import { Collection, collectionLoader } from "./V2/Routes/Settings/Collection/Collection";
import { LibraryTable } from "./Library/LibraryTable";
import ViewerRoute from "./Viewer/ViewerRoute";

import {
  TranslationsList,
  translationsListLoader } from "./V2/Routes/Settings/Translations/TranslationsList";

import {
  EditTranslations,
  editTranslationsLoader,
  editTranslationsAction } from "./V2/Routes/Settings/Translations/EditTranslations";

import { Dashboard, dashboardLoader } from "./V2/Routes/Settings/Dashboard/Dashboard";

import {
  ThesaurusForm,
  theasauriListLoader,
  ThesauriList,
  editTheasaurusLoader } from "./V2/Routes/Settings/Thesauri";


import { MenuConfig, menuConfigloader } from "./V2/Routes/Settings/MenuConfig/MenuConfig";
import {
  RelationshipTypes,
  relationshipTypesLoader } from "./V2/Routes/Settings/RelationshipTypes/RelationshipTypes";

import { LanguagesList, languagesListLoader } from "./V2/Routes/Settings/Languages/LanguagesList";
import { Account, accountLoader } from "./V2/Routes/Settings/Account/Account";
import { IXdashboardLoader, IXDashboard } from "./V2/Routes/Settings/IX/IXDashboard";
import { IXSuggestions, IXSuggestionsLoader } from "./V2/Routes/Settings/IX/IXSuggestions";
import { PageEditor, pageEditorLoader, PagesList, pagesListLoader } from "./V2/Routes/Settings/Pages";
import { customisationLoader, Customisation } from "./V2/Routes/Settings/Customization/Customization";
import { activityLogLoader, ActivityLog } from "./V2/Routes/Settings/ActivityLog/ActivityLog";
import { CustomUploads, customUploadsLoader } from "./V2/Routes/Settings/CustomUploads/CustomUploads";
import { FiltersTable, filtersLoader } from "./V2/Routes/Settings/Filters";
import { loggedInUsersRoute, adminsOnlyRoute, privateRoute } from "./ProtectedRoute";
import { getIndexElement } from "./getIndexElement";
import { PageView } from "./Pages/PageView";
import { RouteErrorBoundary } from "./App/ErrorHandling/RouteErrorBoundary";
import ResetPassword from "./Users/ResetPassword";
import ConnectedUnlockAccount from "./Users/UnlockAccount";
import OneUpReview from "./Review/OneUpReview";
import { NewRelMigrationDashboard } from "./Settings/components/relV2MigrationDashboard";

const getRoutesLayout = (
settings,
indexElement,
headers) => {var _settings$features;return /*#__PURE__*/(

    _jsx(Route, { errorElement: /*#__PURE__*/_jsx(RouteErrorBoundary, {}) }, void 0, /*#__PURE__*/
    _jsx(Route, { index: true, element: indexElement }), /*#__PURE__*/
    _jsx(Route, { path: "login", element: /*#__PURE__*/_jsx(Login, {}) }), /*#__PURE__*/
    _jsx(Route, { path: "library", element: privateRoute( /*#__PURE__*/_jsx(LibraryCards, {}), settings) }), /*#__PURE__*/
    _jsx(Route, { path: "library/map", element: privateRoute( /*#__PURE__*/_jsx(LibraryMap, {}), settings) }), /*#__PURE__*/
    _jsx(Route, { path: "library/table", element: privateRoute( /*#__PURE__*/_jsx(LibraryTable, {}), settings) }), /*#__PURE__*/
    _jsx(Route, { path: "document/:sharedId/*", element: privateRoute( /*#__PURE__*/_jsx(ViewerRoute, {}), settings) }), /*#__PURE__*/
    _jsx(Route, { path: "entity/:sharedId/*", element: privateRoute( /*#__PURE__*/_jsx(ViewerRoute, {}), settings) }), /*#__PURE__*/
    _jsx(Route, { path: "entity/:sharedId/:tabView", element: privateRoute( /*#__PURE__*/_jsx(ViewerRoute, {}), settings) }), /*#__PURE__*/
    _jsx(Route, { path: "error/:errorCode", element: /*#__PURE__*/_jsx(GeneralError, {}) }), /*#__PURE__*/
    _jsx(Route, { path: "404", element: /*#__PURE__*/_jsx(GeneralError, {}) }), /*#__PURE__*/
    _jsx(Route, { path: "page/:sharedId", element: /*#__PURE__*/_jsx(PageView, {}) }), /*#__PURE__*/
    _jsx(Route, { path: "page/:sharedId/:slug", element: /*#__PURE__*/_jsx(PageView, {}) }), /*#__PURE__*/
    _jsx(Route, { path: "setpassword/:key", element: /*#__PURE__*/_jsx(ResetPassword, {}) }), /*#__PURE__*/
    _jsx(Route, { path: "unlockaccount/:username/:code", element: /*#__PURE__*/_jsx(ConnectedUnlockAccount, {}) }), /*#__PURE__*/
    _jsx(Route, { path: "review", element: adminsOnlyRoute( /*#__PURE__*/_jsx(OneUpReview, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "settings", element: loggedInUsersRoute( /*#__PURE__*/_jsx(Settings, {})) }, void 0, /*#__PURE__*/
    _jsx(Route, { path: "account", element: /*#__PURE__*/_jsx(Account, {}), loader: accountLoader(headers) }), /*#__PURE__*/
    _jsx(Route, {
      path: "dashboard",
      element: adminsOnlyRoute( /*#__PURE__*/_jsx(Dashboard, {})),
      loader: dashboardLoader(headers) }
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "navlinks",
      element: adminsOnlyRoute( /*#__PURE__*/_jsx(MenuConfig, {})),
      loader: menuConfigloader(headers) }
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "collection",
      element: adminsOnlyRoute( /*#__PURE__*/_jsx(Collection, {})),
      loader: collectionLoader(headers) }
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "users",
      element: adminsOnlyRoute( /*#__PURE__*/_jsx(Users, {})),
      loader: usersLoader(headers),
      action: userAction() }
    ), /*#__PURE__*/
    _jsx(Route, { path: "preserve", element: adminsOnlyRoute( /*#__PURE__*/_jsx(PreserveSettings, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "pages" }, void 0, /*#__PURE__*/
    _jsx(Route, { index: true, element: adminsOnlyRoute( /*#__PURE__*/_jsx(PagesList, {})), loader: pagesListLoader(headers) }), /*#__PURE__*/
    _jsx(Route, {
      path: "page/:sharedId?",
      element: adminsOnlyRoute( /*#__PURE__*/_jsx(PageEditor, {})),
      loader: pageEditorLoader(headers) }
    )
    ), /*#__PURE__*/
    _jsx(Route, { path: "templates" }, void 0, /*#__PURE__*/
    _jsx(Route, { index: true, element: adminsOnlyRoute( /*#__PURE__*/_jsx(EntityTypesList, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "new", element: adminsOnlyRoute( /*#__PURE__*/_jsx(NewTemplate, {})) }), /*#__PURE__*/
    _jsx(Route, { path: "edit/:templateId", element: adminsOnlyRoute( /*#__PURE__*/_jsx(EditTemplate, {})) })
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "metadata_extraction",
      element: adminsOnlyRoute( /*#__PURE__*/_jsx(IXDashboard, {})),
      loader: IXdashboardLoader(headers) }
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "metadata_extraction/suggestions/:extractorId",
      loader: IXSuggestionsLoader(headers),
      element: adminsOnlyRoute( /*#__PURE__*/_jsx(IXSuggestions, {})) }
    ), /*#__PURE__*/
    _jsx(Route, { path: "relationship-types" }, void 0, /*#__PURE__*/
    _jsx(Route, {
      index: true,
      element: adminsOnlyRoute( /*#__PURE__*/_jsx(RelationshipTypes, {})),
      loader: relationshipTypesLoader(headers) }
    )
    ), /*#__PURE__*/

    _jsx(Route, { path: "thesauri" }, void 0, /*#__PURE__*/
    _jsx(Route, {
      index: true,
      element: adminsOnlyRoute( /*#__PURE__*/_jsx(ThesauriList, {})),
      loader: theasauriListLoader(headers) }
    ), /*#__PURE__*/
    _jsx(Route, { path: "new", element: adminsOnlyRoute( /*#__PURE__*/_jsx(ThesaurusForm, {})) }), /*#__PURE__*/
    _jsx(Route, {
      path: "edit/:_id",
      element: adminsOnlyRoute( /*#__PURE__*/_jsx(ThesaurusForm, {})),
      loader: editTheasaurusLoader(headers) }
    )
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "languages",
      element: adminsOnlyRoute( /*#__PURE__*/_jsx(LanguagesList, {})),
      loader: languagesListLoader(headers) }
    ), /*#__PURE__*/
    _jsx(Route, { path: "translations" }, void 0, /*#__PURE__*/
    _jsx(Route, {
      index: true,
      element: adminsOnlyRoute( /*#__PURE__*/_jsx(TranslationsList, {})),
      loader: translationsListLoader(headers) }
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "edit/:context",
      element: adminsOnlyRoute( /*#__PURE__*/_jsx(EditTranslations, {})),
      loader: editTranslationsLoader(headers),
      action: editTranslationsAction() }
    )
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "filters",
      element: adminsOnlyRoute( /*#__PURE__*/_jsx(FiltersTable, {})),
      loader: filtersLoader(headers) }
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "customisation",
      element: adminsOnlyRoute( /*#__PURE__*/_jsx(Customisation, {})),
      loader: customisationLoader(headers) }
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "activitylog",
      element: adminsOnlyRoute( /*#__PURE__*/_jsx(ActivityLog, {})),
      loader: activityLogLoader(headers) }
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "custom-uploads",
      element: adminsOnlyRoute( /*#__PURE__*/_jsx(CustomUploads, {})),
      loader: customUploadsLoader(headers) }
    ), /*#__PURE__*/
    _jsx(Route, {
      path: "newrelmigration",
      element:
      settings !== null && settings !== void 0 && (_settings$features = settings.features) !== null && _settings$features !== void 0 && _settings$features.newRelationships ? /*#__PURE__*/_jsx(NewRelMigrationDashboard, {}) : /*#__PURE__*/_jsx(GeneralError, {}) }

    )
    )
    ));};


const getRoutes = (
settings,
userId,
headers) =>
{
  const { element, parameters } = getIndexElement(settings, userId);
  const layout = getRoutesLayout(settings, element, headers);
  return createRoutesFromElements( /*#__PURE__*/
    _jsx(Route, { path: "/", element: /*#__PURE__*/_jsx(App, { customParams: parameters }) }, void 0,
    layout, /*#__PURE__*/
    _jsx(Route, { path: ":lang" }, void 0,
    layout, /*#__PURE__*/
    _jsx(Route, { path: "*", element: /*#__PURE__*/_jsx(GeneralError, {}) })
    ), /*#__PURE__*/
    _jsx(Route, { path: "*", element: /*#__PURE__*/_jsx(GeneralError, {}) })
    )
  );
};

export { getRoutes };